/**
 * Sound scope gate.
 *
 * Game sound effects should only be audible while a TABLE surface is showing —
 * a single table (`/table/:id/:type`) or the multi-table grid (`/grid`) — and
 * NOT in the lobby. The multi-table grid stays mounted even while the lobby is
 * shown, so without this gate background tables would keep making noise over the
 * lobby.
 *
 * This is derived from the URL — the same source of truth as
 * `ViewManagerContext.activeView` — rather than React context, so it is correct
 * no matter where in the provider tree the caller sits (the shared `useSound`
 * wrapper and the per-cell `GlobalProvider`s live at different depths, and the
 * app-level `GlobalProvider` sits ABOVE `ViewManagerProvider` entirely).
 *
 * The waitlist "Table Ready" alert opts out of this gate (see `useSound`'s
 * `alwaysPlay` option) so it is also heard in the lobby.
 */
export const areTableSoundsEnabled = (): boolean => {
  if (typeof window === 'undefined' || !window.location) return true;
  const path = window.location.pathname || '';
  return path.startsWith('/table/') || path === '/grid';
};
